<template>
  <header :class="{ active: menuActive }">
    <div class="container-fluid container-lg">
      <nav class="navbar navbar-expand-md align-items-center justify-content-lg-between">
        <a href="/" class="d-flex align-items-center col-sm col-lg-3 text-dark text-decoration-none">
          <img src="@/assets/img/yoda-icon-white.svg" alt="Logo" title="Logo" class="logo" />
        </a>
        <div
            :class="{ 'show': mobileMenuShow }"
            class="collapse navbar-collapse col-lg-auto justify-content-md-center">
            <ul class="nav">
              <li v-for="(item, key) in menu" v-bind:key="key">
                <a
                  @click="scrollToSection(item.link)"
                  class="nav-link" >
                  {{ item.name }}
                </a>
              </li>
            </ul>
            <ul class="side-nav-links">
              <li v-for="(m, index) in sideMenu" :key="index">
                <a
                    :href="m.src"
                    :title="m.name"
                    :alt="m.name"
                    target="_blank"
                    class="nav-link-icon">
                  <i :class="m.icon"></i>
                </a>
              </li>
            </ul>
        </div>
        <div class="col-sm col-lg-3 text-lg-end d-none d-md-block">
          <ul class="side-nav-links">
            <li v-for="(m, index) in sideMenu" :key="index">
              <a
                 :href="m.src"
                 :title="m.name"
                 :alt="m.name"
                 target="_blank"
                 class="nav-link-icon">
                  <i :class="m.icon"></i>
              </a>
            </li>
          </ul>
        </div>
        <button
            :class="{ 'active': mobileMenuShow}"
            id="menu-btn"
            @click="toggleMobileMenu()"
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            aria-label="Toggle navigation">
            <span id="menu-wrapper">
              <span id="menu-bar"></span>
            </span>
        </button>
      </nav>
    </div>
  </header>
</template>
<style scoped>
  a.nav-link {
    cursor: pointer;
  }
</style>
<script>
export default {
  name: 'NavigationComponent',
  data () {
    return {
      menu: [
        {
          name: 'About Me',
          link: 'about'
        },
        {
          name: 'Skillset',
          link: 'skills'
        },
        {
          name: 'Resume',
          link: 'resume'
        },
        {
          name: 'Contact',
          link: 'contact'
        },
      ],
      sideMenu: [
        {
          name: 'Linkedin',
          src: 'https://www.linkedin.com/in/martin-matovski-21b965150/',
          icon: 'lab la-linkedin-in'
        },
        {
          name: 'Github',
          src: 'https://github.com/MartinTheCreator',
          icon: 'lab la-github'
        },
        {
          name: 'Email',
          src: 'https://www.linkedin.com/in/martin-matovski-21b965150/',
          icon: 'las la-at'
        }
      ],
      menuActive: false,
      mobileMenuShow: false,
    }
  },
  methods: {
    scrollToSection (section) {
      this.$emit('scrollToSection', section)
    },
    toggleMobileMenu () {
      this.mobileMenuShow = !this.mobileMenuShow
      this.$emit('mobileMenuHandler')
    },
    toogleStickyMenu () {
      const posY = window.pageYOffset
      if (posY) {
        this.menuActive = true
      } else {
        this.menuActive = false
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.toogleStickyMenu()
    })
  }
}
</script>
